<template>
  <div class="order">
    <Loading v-if="loading" />
    <div class="order__header">
      <div>
        <p>{{ $t('order') }}</p>
        <p
          class="subtitle"
          v-if="order.deliveryStatus === 'expired' && !order.deliveryTime"
        >
          {{ $t('reservation') }}
        </p>
        <p
          class="subtitle"
          v-if="order.deliveryStatus === 'expired' && order.deliveryTime"
        >
          {{ $t('delivery') }}
        </p>
      </div>

      <img
        v-if="order.status !== 'inactive' && order.deliveryStatus"
        src="@/assets/icons/DownloadBlack.svg"
        alt=""
        @click="getCSV"
      />
    </div>
    <div class="order__isOrder" v-if="order.deliveryStatus">
      <div class="info" v-if="order.phoneNumber">
        <p>{{ $t('mobilePhone') }}</p>
        <span>{{ order.phoneNumber }}</span>
      </div>
      <div class="info" v-if="order.deliveryUserName">
        <p>{{ $t('deliveryMadeBy') }}</p>
        <span>{{ order.deliveryUserName }}</span>
      </div>
      <div class="info">
        <p>{{ $t('ssn') }}</p>
        <span>{{ getDataSSN() }}</span>
        <Button
          class="ssn_btn"
          variant="notBordered"
          :title="!showDecodedSsn ? $t('show') : ''"
          @click="showSsn()"
        />
      </div>

      <div
        class="info kolli-id"
        v-if="order.deliveryId"
        :idActiveDelivery="idActiveDelivery"
        @click="openQRCode"
      >
        <p>{{ $t('kolliID') }}</p>
        <span>{{ getIds(order.deliveryId, order.additionalDeliveryIds) }}</span>
      </div>
      <div class="info" v-if="order.fulfillment_order_id">
        <p>{{ $t('fulfillment_order_id') }}</p>
        <span>{{ order.fulfillment_order_id }}</span>
      </div>
      <div class="info" v-if="order.order_id">
        <p>{{ $t('order_id') }}</p>
        <span>{{ order.order_id }}</span>
      </div>
      <div class="info" v-if="order">
        <p>{{ $t('includesDrug') }}</p>
        <span>{{ getIsDrud(order.is_drug) }}</span>
      </div>
      <div class="info" v-if="order.deliveryTime || order.deliveryUserName">
        <p>{{ $t('delivered') }}</p>
        <span
          >{{ order.deliveryUserName }} {{ dateTime(order.deliveryTime) }}</span
        >
      </div>
      <div class="info" v-if="order.deleteTime || order.deleteUserName">
        <p>{{ $t('deleted') }}</p>
        <span>{{ order.deleteUserName }} {{ dateTime(order.deleteTime) }}</span>
      </div>
      <div class="info" v-if="order.reservedUserName || order.reservedTime">
        <p>{{ $t('reserved') }}</p>
        <span
          >{{ order.reservedUserName }} {{ dateTime(order.reservedTime) }}</span
        >
      </div>
      <div class="info" v-if="order.assignedUserName || order.assignedTime">
        <p>{{ $t('assignedUserName') }}</p>
        <span
          >{{ order.assignedUserName }} {{ dateTime(order.assignedTime) }}</span
        >
      </div>
      <div class="info" v-if="order.removedUserName || order.removedTime">
        <p>{{ $t('removed') }}</p>
        <span
          >{{ order.removedUserName }} {{ dateTime(order.removedTime) }}</span
        >
      </div>
      <div class="info" v-if="order.pickupTime">
        <p>{{ $t('timePickup') }}</p>
        <span>{{ dateTime(order.pickupTime) }}</span>
      </div>
      <div class="info" v-if="order.descriptionText">
        <p>{{ $t('description') }}</p>
        <span>{{ order.descriptionText }}</span>
      </div>
      <div class="info" v-if="order.resendSMSCounter">
        <p>{{ $t('resendSMSCounter') }}</p>
        <span>{{ order.resendSMSCounter }}</span>
      </div>
      <div class="info" v-if="order.resendSMSTimestamps">
        <p>{{ $t('resendSMSTimestamps') }}</p>
        <span>{{ dateTime(isLastTime) }}</span>
      </div>
    </div>
    <div
      class="order__noOrder"
      v-if="!order.deliveryStatus && order.status !== 'inactive'"
    >
      <div class="img">
        <img src="@/assets/icons/Order.svg" alt="" />
      </div>
      <div class="title">
        <p>{{ $t('noOrderReservedYet') }}</p>
      </div>
    </div>
    <div class="order__noOrder" v-if="order.status === 'inactive'">
      <div class="img">
        <img src="@/assets/icons/Order.svg" alt="" />
      </div>
      <div class="title">
        <p>{{ $t('enableLocker') }}</p>
      </div>
    </div>
  </div>
  <div class="footer-order">
    <div
      :class="{
        'button-active': true,
        tootip:
          !activePickupBox?.info.active && order.deliveryStatus !== 'reserved'
      }"
    >
      <Button
        v-if="hideButton(order)"
        :class="{
          'order-button': true,
          'resendSMS-button': order.deliveryStatus === 'delivered'
        }"
        :variant="getVariant()"
        :title="$t(getTitle())"
        @click="getActions()"
      />
      <span
        v-if="
          !activePickupBox?.info.active && order.deliveryStatus !== 'reserved'
        "
        class="tooltiptext"
      >
        {{ $t('pickupboxIsInactive') }}
      </span>
    </div>
    <div
      :class="{
        'button-active': true,
        tootip: !activePickupBox?.info.active
      }"
    >
      <Button
        v-if="order.status !== 'inactive' && !order.deliveryStatus"
        class="assignReservation-button"
        :variant="activePickupBox?.info.active ? 'filled' : 'disabled'"
        :title="$t('assignReservation')"
        @click="assignReservation"
      />
      <span v-if="!activePickupBox?.info.active" class="tooltiptext">
        {{ $t('pickupboxIsInactive') }}
      </span>
    </div>
  </div>
  <DeleteReservation
    :showModal="showModal"
    @closeModal="showModal = false"
    @deleteReservationRequest="deleteReservationRequest"
    @destroyReservationRequest="destroyReservationRequest"
  />
  <ReserveLocker
    v-if="showModalReserveLocker"
    :showModalReserveLocker="showModalReserveLocker"
    @closeModal="showModalReserveLocker = false"
    :activePickupBox="activePickupBox"
    :selectedLockers="activeLocker"
  />
  <ChooseDelivery
    :showModalChooseDelivery="showModalChooseDelivery"
    :activeBoxId="activeBoxId"
    :deliveryId="deliveryId"
    :activeLocker="activeLocker"
    @closeModal="showModalChooseDelivery = false"
  />
  <ResendSMS
    :showModalResendSMS="showModalResendSMS"
    :activeBoxId="activeBoxId"
    :deliveryId="deliveryId"
    @closeModal="showModalResendSMS = false"
  />
  <OpenQRCode
    :showQRCode="showQRCode"
    :idActiveDelivery="idActiveDelivery"
    @closeModal="showQRCode = false"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import moment from 'moment';
import router from '@/router';

import DeleteReservation from './DeleteReservation/DeleteReservation.vue';
import ReserveLocker from '@/duplicatePages/ReserveLocker/ReserveLocker.vue';
import ChooseDelivery from './ChooseDelivery/ChooseDelivery.vue';
import ResendSMS from '@/duplicatePages/ResendSMS/ResendSMS.vue';
import OpenQRCode from '@/duplicatePages/OpenQRCode/OpenQRCode.vue';

import Loading from '@/views/Loading.vue';

import { columns } from './configs';

import { OrderData } from '@/store/modules/pharmacy/types';
import { downloadCSV } from '@/utils/downloadCSV';

@Options({
  name: 'Order',
  emits: [
    'deleteReservationRequest',
    'getDecodedSsn',
    'destroyReservationRequest'
  ],
  props: ['order', 'activePickupBox', 'activeLocker', 'showDecodedSsn'],
  components: {
    DeleteReservation,
    ReserveLocker,
    ChooseDelivery,
    ResendSMS,
    OpenQRCode,
    Loading
  },
  data() {
    return {
      columns: columns(this.$t),
      showModal: false,
      showModalReserveLocker: false,
      showModalChooseDelivery: false,
      showModalResendSMS: false,
      activeBoxId: '',
      dataSsn: '',
      deliveryId: '',
      loading: false,
      showQRCode: false,
      idActiveDelivery: ''
    };
  },
  computed: {
    isLastTime() {
      return this.order.resendSMSTimestamps[
        this.order.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },
  methods: {
    ...mapActions('pharmacy', [
      'deleteReservation',
      'getPickupBoxesByPharmacy',
      'destroyReservation'
    ]),
    showSsn() {
      this.$emit('getDecodedSsn');
    },
    getDataSSN() {
      if (this.showDecodedSsn) {
        return this.dataSsn.length && this.showDecodedSsn
          ? this.dataSsn
          : this.$t('noSsn');
      } else {
        return '************';
      }
    },
    hideButton(order: OrderData) {
      if (!order.lockerId) {
        return false;
      } else if (order.deliveryStatus === 'expired' && order.deliveryTime) {
        return false;
      } else if (
        order.status !== 'inactive' &&
        order.deliveryStatus !== 'removed'
      ) {
        return true;
      } else {
        return false;
      }
    },
    getIsDrud(value: boolean) {
      if (value) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    },
    dateTime(value: number) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getCSV(): void {
      const data = [this.order].map((el: OrderData) => ({
        deliveryId: this.getIds(el.deliveryId, el.additionalDeliveryIds),
        deliveryMadeBy: el.deliveryMadeBy,
        phoneNumber: el.phoneNumber,
        reservedTime: this.dateTime(el.reservedTime),
        assignedTime: this.dateTime(el.assignedTime)
      }));

      const columns = [...this.columns];

      downloadCSV(data, columns, 'Order.csv');
    },
    deleteThisReservation() {
      this.showModal = true;
    },
    async deleteReservationRequest() {
      this.loading = true;

      await this.deleteReservation({
        boxId: this.activePickupBox.id,
        deliveryId: this.order.deliveryId
      });

      this.showModal = false;

      const { id } = this.$route.params;

      router.push({
        name: 'Lockers',
        params: { id, boxId: this.activePickupBox.id }
      });

      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;
    },
    async destroyReservationRequest() {
      const { id } = this.$route.params;

      const payload = {
        pharmacyId: id,
        deliveryId: this.order.deliveryId,
        pickupboxId: this.activePickupBox.id
      };

      await this.destroyReservation(payload);
      this.showModal = false;

      router.push({
        name: 'Lockers',
        params: { id, boxId: this.activePickupBox.id }
      });

      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;
    },
    reserve() {
      this.showModalReserveLocker = true;
    },
    resendSMS() {
      this.deliveryId = this.order.deliveryId;
      this.activeBoxId = this.activePickupBox.id;

      this.showModalResendSMS = true;
    },
    assignReservation() {
      if (this.activePickupBox?.info.active) {
        this.activeBoxId = this.activePickupBox.id;
        this.showModalChooseDelivery = true;
      } else {
        this.showModalChooseDelivery = false;
      }
    },
    getVariant() {
      if (this.order.deliveryStatus === 'expired' && !this.order.deliveryTime) {
        return 'redBorderedBackground';
      } else if (
        this.order.deliveryStatus === 'expired' &&
        this.order.deliveryTime
      ) {
        return '';
      }

      if (
        !this.activePickupBox?.info.active &&
        this.order.deliveryStatus !== 'reserved'
      ) {
        return 'disabled';
      }

      if (this.order.deliveryStatus === 'reserved') {
        return 'redBorderedBackground';
      } else if (
        !this.order.deliveryStatus ||
        this.order.status !== 'inactive' ||
        this.order.deliveryStatus === 'delivered'
      ) {
        return 'filled';
      } else {
        return '';
      }
    },
    getTitle() {
      if (
        this.order.deliveryStatus === 'reserved' ||
        (this.order.deliveryStatus === 'expired' && !this.order.deliveryTime)
      ) {
        return 'deleteReservation';
      } else if (
        !this.order.deliveryStatus &&
        this.order.status !== 'inactive'
      ) {
        return 'reserve';
      } else if (this.order.deliveryStatus === 'delivered') {
        return 'resendSMS';
      } else {
        return '';
      }
    },
    getActions() {
      if (
        !this.activePickupBox?.info.active &&
        this.order.deliveryStatus !== 'reserved'
      ) {
        return this.showModalReserveLocker === false;
      }

      if (this.order.deliveryStatus === 'reserved') {
        return this.deleteThisReservation();
      } else if (
        !this.order.deliveryStatus &&
        this.order.status !== 'inactive'
      ) {
        return this.reserve();
      } else if (this.order.deliveryStatus === 'delivered') {
        return this.resendSMS();
      } else if (
        this.order.deliveryStatus === 'expired' &&
        !this.order.deliveryTime
      ) {
        return this.deleteThisReservation();
      }
    },
    openQRCode() {
      this.idActiveDelivery = this.order.deliveryId;

      this.showQRCode = true;
    }
  },
  watch: {
    showDecodedSsn() {
      if (this.showDecodedSsn) {
        this.dataSsn = this.showDecodedSsn;
      } else {
        this.dataSsn = this.$t('noSsn');
      }
    }
  }
})
export default class Order extends Vue {}
</script>

<style lang="scss" scoped>
.order {
  height: 400px;
  border: 1px solid $border;
  border-radius: 8px;
  margin: 0 17px;
  overflow-y: scroll;
  .order__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 43px;
    padding: 0 17px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid $border;
    p {
      font-family: 'Ubuntu-Medium';
    }
    img {
      cursor: pointer;
    }
    .subtitle {
      font-family: 'Ubuntu-Regular';
      font-size: $twelveSize;
    }
  }
  .order__isOrder {
    margin: 14px 17px;
    .info {
      &.kolli-id {
        cursor: pointer;
      }
      margin-bottom: 24px;
      p {
        color: $label;
        font-size: $twelveSize;
        line-height: $fourteenSize;
      }
      span {
        color: $mid-grey;
        font-size: $fourteenSize;
      }
      .ssn_btn {
        width: 0;
        height: 0;
      }
    }
  }
  .order__noOrder {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-top: 70px;
    .title {
      p {
        text-align: center;
        width: 195px;
        font-size: $fourteenSize;
        line-height: $twentyOneSize;
        font-weight: 400;
        color: $label;
      }
    }
  }
}

.footer-order {
  margin: 17px;
  background-color: $light-grey;
}

.button-active {
  display: inline-block;
  background-color: $light-grey;
  .disabled {
    width: 158px;
  }
  .resendSMS-button {
    width: 170px;
  }
  .assignReservation-button {
    width: 270px;
  }
}

.tootip {
  position: relative;
  display: inline-block;
  .tooltiptext {
    position: absolute;
    top: -60%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    width: 150px;
    font-size: $elevenSize;
    line-height: $elevenSize;
    background: $label;
    color: $white;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $label transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}
</style>
